var data = {
  "width": 24,
  "height": 24,
  "body": "<g id=\"evaCheckmarkCircle2Fill0\"><g id=\"evaCheckmarkCircle2Fill1\"><path id=\"evaCheckmarkCircle2Fill2\" fill=\"currentColor\" d=\"M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Zm4.3 7.61l-4.57 6a1 1 0 0 1-.79.39a1 1 0 0 1-.79-.38l-2.44-3.11a1 1 0 0 1 1.58-1.23l1.63 2.08l3.78-5a1 1 0 1 1 1.6 1.22Z\"/></g></g>"
};
exports.__esModule = true;
exports.default = data;